export class GeoData {
  constructor(
    public longitude: number = undefined,
    public latitude: number = undefined,
    public address: string = ''
  ) {

  }
}
